import { useQuery } from '@tanstack/react-query';
import sessionsService from '@/lib/api/sessions';
import type { SalesAnalyticsResponse } from '@/lib/api/sessions';

export function useSessionDetail(sessionId: string | undefined | null) {
  return useQuery({
    queryKey: ['salesAnalytics', sessionId],
    queryFn: async () => {
      if (!sessionId) throw new Error('Session ID required');

      const response = await sessionsService.getSalesAnalytics(sessionId);

      if (!response.success || !response.data) {
        throw new Error(response.error || 'Failed to fetch session analytics');
      }

      return response.data;
    },
    enabled: !!sessionId,
    staleTime: 5 * 60 * 1000, // Consider fresh for 5 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
  });
}
